import { Component, OnDestroy, OnInit, inject } from '@angular/core'
import { User } from '../../../models/user'
import { DeviceDetectorService } from 'ngx-device-detector'
import { RouteParamsService } from '../../../services/route-params.service'
import { Subscription } from 'rxjs'
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'lg-navbar-secondary-menu',
    templateUrl: './navbar-secondary-menu.component.html',
    styleUrls: ['./navbar-secondary-menu.component.scss'],
    imports: [RouterLinkActive, RouterLink]
})
export class NavbarSecondaryMenuComponent implements OnInit, OnDestroy {
  deviceService = inject(DeviceDetectorService);
  private routeParamsService = inject(RouteParamsService);

  subscription = new Subscription()
  user: User
  chantierCode: string

  ngOnInit(): void {
    this.subscription.add(
      this.routeParamsService.chantierCode.subscribe((chantierCode) => {
        this.chantierCode = chantierCode
      })
    )
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}
